import {
  FETCH_SUGGESTIONS_REQUEST,
  FETCH_SUGGESTIONS_SUCCESS,
  FETCH_SUGGESTIONS_FAIL,
} from '../actions/suggestions';

const initialState = {
  suggestions: [],
  loading: false,
  error: null,
};

const suggestionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUGGESTIONS_REQUEST:
      return { ...state, loading: true, suggestions: [] };

    case FETCH_SUGGESTIONS_SUCCESS:
      return { ...state, loading: false, suggestions: action.payload };

    case FETCH_SUGGESTIONS_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default suggestionsReducer;
